import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import AgingReportSearch from "./AgingReportSearch";
import { reportService } from "_services";

import { Breadcrumb, PageHeader, Spin, Table, Tooltip } from "antd";

function AgingReports() {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [agingData, setAgingData] = useState([]);

  useEffect(() => {
    setIsLoading(true);

    getAllAgingData();
  }, []);

  const getAgingDataColumns = () => {
    let columns = [];

    columns.push({
      title: "HS Code",
      dataIndex: "materialCode",
      key: "materialCode",
      width: "5%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    columns.push({
      title: "Company Code",
      dataIndex: "materialCompanyCode",
      key: "materialCompanyCode",
      width: "5%",

      render: (text, record) => (
        <Tooltip title={text}>{text?.substring(0, 8)}</Tooltip>
      ),
    });

    columns.push({
      title: "Name",
      dataIndex: "materialName",

      key: "materialName",
      width: "15%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    columns.push({
      title: "0-3 Months",
      align: "center",
      dataIndex: "ageLt90",
      key: "ageLt90",
      width: "5%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    columns.push({
      title: "3-6 Months",
      align: "center",
      dataIndex: "age90To180",
      key: "age90To180",
      width: "5%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    columns.push({
      title: "6-9 Months",
      align: "center",
      dataIndex: "age180To270",
      key: "age180To270",
      width: "5%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    columns.push({
      title: "9-12 Months",
      align: "center",
      dataIndex: "age270To360",
      key: "age270To360",
      width: "5%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    columns.push({
      title: " ~ > 12 Months",
      align: "center",
      dataIndex: "ageGt360",
      key: "ageGt360",
      width: "5%",
      render: (text, record) => {
        if (text) {
          return `${text}`;
        }
      },
    });

    return columns;
  };
  const getAllAgingData = () => {
    setIsLoading(true);
    reportService
      .getAgingData()
      .then((data) => {
        setAgingData(data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error);
      });
  };

  const getAgingSearchData = (values) => {
    if (!values?.bomId) {
      setAgingData([]);
      return;
    }

    let params = `?ageRange=${values?.duration ?? "AGE_LT_90"}&product=${
      values?.bomId
    }`;
    setIsLoading(true);
    reportService
      .getAgingDataSearch(params)
      .then((data) => {
        setAgingData(data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error);
      });
  };
  const onSearch = (values) => {
    getAgingSearchData(values);
  };
  const onClear = () => {
    getAllAgingData();
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/reports">Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/reports/Aging-Reports">Aging Reports</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Page error={error}>
          <Spin spinning={isLoading}>
            <AgingReportSearch onSearch={onSearch} onClear={onClear} />

            {agingData && (
              <Table
                bordered
                pagination={false}
                columns={getAgingDataColumns()}
                dataSource={agingData}
                size="small"
              ></Table>
            )}
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default AgingReports;
